<template>
  <WrapperCell
      code="benefit_discount"
      label="Скидка"
      :icon="ICONS.percentage"
      icon-size="14px"
      @open="onClick"
      :active="active"
      :mode="mode"
      v-if="discountBenefitsStandaloneBest"
  >
    {{ discountBenefitsStandaloneBest?.DISCOUNT_PERCENT }}%
  </WrapperCell>
</template>

<script lang="ts" setup>

import {ICONS} from "@/assets/icons";
import WrapperCell from "@/components/Shop/VOrder/ui/Section/Wrapper/WrapperCell.vue";
import {useBasketRulesStore} from "@/modules/shop/store/basket-rules";
import {storeToRefs} from "pinia";
import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";

const basketRulesStore = useBasketRulesStore()

const {discountBenefitsStandaloneBest} = storeToRefs(basketRulesStore)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})

</script>

<style scoped>

</style>
